import { Globe, Workflow, RefreshCcw } from "lucide-react";

const pillars = [
  {
    icon: Globe,
    color: "#00f0ff",
    title: "Websites That Win Clients",
    desc: "A sharp, professional website is your first impression. We design and develop sites that make your business look credible, established, and worth choosing — built to attract and convert more clients.",
    tags: ["Brand elevation", "Conversion-focused", "Mobile-first"],
  },
  {
    icon: Workflow,
    color: "#ff003c",
    title: "Apps That Automate Work",
    desc: "Custom mobile apps and internal tools that automate processes and improve workflows — online ordering, scheduling, intake, and operations running on autopilot instead of manual effort.",
    tags: ["Process automation", "Workflow design", "iOS & Android"],
  },
  {
    icon: RefreshCcw,
    color: "#00f0ff",
    title: "Updates & Full Management",
    desc: "We don't just build and disappear. Gsoftware updates, maintains, and fully manages your website and apps on an ongoing basis — so your tech never goes stale or breaks when you need it most.",
    tags: ["Ongoing updates", "Priority support", "Fully managed"],
  },
];

export default function Services() {
  return (
    <section id="services" className="relative border-t border-white/5 bg-[#050505] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#00f0ff]">// What we do</p>
          <h2 className="font-display mt-4 text-3xl font-black tracking-tight sm:text-4xl">
            Built. Updated. <span className="text-[#00f0ff] text-glow-cyan">Managed.</span>
          </h2>
          <p className="mt-4 text-base text-white/50 md:text-lg">
            One partner for your entire digital operation — from launch day to every update after.
          </p>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {pillars.map((p, i) => (
            <article
              key={p.title}
              data-testid={`service-card-${i + 1}`}
              className="group relative border border-white/10 bg-[#0a0a0a] p-8 transition-colors duration-300 hover:border-white/25 lg:p-10"
            >
              <div
                className="absolute left-0 top-0 h-1 w-full opacity-60 transition-opacity duration-300 group-hover:opacity-100"
                style={{ background: p.color, boxShadow: `0 0 14px ${p.color}` }}
              />
              <p.icon size={34} style={{ color: p.color }} strokeWidth={1.5} />
              <h3 className="font-display mt-6 text-lg font-bold leading-snug">{p.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-white/50">{p.desc}</p>
              <div className="mt-6 flex flex-wrap gap-2">
                {p.tags.map((t) => (
                  <span
                    key={t}
                    className="font-mono-tech border border-white/10 px-2.5 py-1 text-[10px] uppercase tracking-widest text-white/40"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
